import { useState } from "react";

interface EpisodeListProps {
  total: number;
  onSelect: (index: number) => void;
}

export default function EpisodeList({ total, onSelect }: EpisodeListProps) {
  const [expanded, setExpanded] = useState(false);
  const episodes = Array.from({ length: total }, (_, i) => i + 1);
  const visible = expanded ? episodes : episodes.slice(0, 12);

  return (
    <div>
      <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8 gap-2.5">
        {visible.map((ep) => (
          <button
            key={ep}
            type="button"
            onClick={() => onSelect(ep)}
            className="h-10 rounded-md bg-background-100 border border-background-200 text-sm text-foreground-700 hover:bg-primary-500 hover:text-background-50 hover:border-primary-500 transition-colors flex items-center justify-center"
          >
            第 {ep} 集
          </button>
        ))}
      </div>
      {episodes.length > 12 && (
        <button
          type="button"
          onClick={() => setExpanded((v) => !v)}
          className="mt-4 mx-auto flex items-center gap-1 text-sm text-accent-600 hover:text-accent-700 transition-colors"
        >
          {expanded ? "收起剧集" : `展开全部 ${total} 集`}
          <i className={expanded ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"}></i>
        </button>
      )}
    </div>
  );
}